import React from 'react';
import PropTypes from 'prop-types';

import { Accordion, ContentBody, Link } from '@lanl-web/lanl-components';
import { getImageUrl, replaceElements } from '../../utils';

import './LinksTable.scss';

export const LinksTable = (props) => {
  const { description, title, resources } = props;

  const groups = [
    ...new Set(
      resources
        ?.map(({ wm_resources_id }) => wm_resources_id?.group_name ?? '')
        ?.filter((name) => name !== ''),
    ),
  ];

  const resourceCard = (resourceArray) => {
    return (
      <div className='links-box'>
        {resourceArray.map(
          (
            {
              link,
              name,
              group_name,
              image_file,
              image_link,
              is_document,
              document,
            },
            index,
          ) => {
            const isDocument = is_document ?? false;
            return (
              <div key={`resource-card-${index}`} className='resource-card'>
                <div className='resource-img'>
                  <img
                    src={
                      isDocument
                        ? getImageUrl(image_file?.filename_disk ?? '')
                        : image_link
                    }
                    alt={name}
                    loading='lazy'
                    width='290'
                    height='350'
                  />
                </div>
                <Link
                  href={
                    isDocument
                      ? getImageUrl(document?.filename_disk ?? '')
                      : link
                  }
                  target='_blank'
                >
                  {name}
                </Link>
              </div>
            );
          },
        )}
      </div>
    );
  };

  const accordionItems = groups.map((name) => ({
    title: name,
    content: resourceCard(
      resources
        ?.map(({ wm_resources_id }) => ({ ...wm_resources_id }))
        ?.filter(({ group_name }) => group_name === name),
    ),
  }));

  return (
    <section className='resource-links'>
      <h2>{title}</h2>
      <ContentBody isHTML body={replaceElements(description)} />
      {groups?.length > 0 && (
        <Accordion accordionItems={accordionItems} isReact={true} />
      )}
      {resourceCard(
        resources
          ?.map(({ wm_resources_id }) => ({ ...wm_resources_id }))
          ?.filter(({ group_name }) => !groups?.includes(group_name)),
      )}
    </section>
  );
};

LinksTable.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  resources: PropTypes.array,
  title: PropTypes.string,
};

export default LinksTable;
